const THRESHOLD_IS_LOADING = 'THRESHOLD_IS_LOADING';
const THRESHOLD_NOTIFICATIONS_IS_LOADING = 'THRESHOLD_NOTIFICATIONS_IS_LOADING';
const FETCH_THRESHOLDS_SUCCESS = 'FETCH_THRESHOLDS_SUCCESS';
const FETCH_THRESHOLD_NOTIFICATIONS_SUCCESS = 'FETCH_THRESHOLD_NOTIFICATIONS_SUCCESS';
const THRESHOLD_NOTIFICATION_SELECTED_ROWS = 'THRESHOLD_NOTIFICATION_SELECTED_ROWS';
const DELETING_THRESHOLDS = 'DELETING_THRESHOLDS';
const DELETING_THRESHOLDS_SUCCESS = 'DELETING_THRESHOLDS_SUCCESS';
const MODIFYING_THRESHOLD_RESPONSE = 'MODIFYING_THRESHOLD_RESPONSE';
const MODIFYING_THRESHOLD = 'MODIFYING_THRESHOLD';
const CREATING_THRESHOLD = 'CREATING_THRESHOLD';
const CREATING_THRESHOLD_RESPONSE = 'CREATING_THRESHOLD_RESPONSE';

const initialState = {
  thresholdLoader: true,
  thresholdNotificationsLoader: true,
  deletingThresholds: false,
  deletingThresholdsSuccess: false,
  thresholds: [],
  notifications: [],
  eventName: '',
  selectedThresholdNotificationRows: [],
  defaultColDefs: {
    sortable: true,
    filter: true,
    resizable: true,
  },
  modifyingThreshold: false,
  modifyingThresholdResponse: true,
  creatingThreshold: false,
  creatingThresholdResponse: true,
};

const thresholdNotifications = (state = initialState, action) => {
  switch (action.type) {
    case THRESHOLD_IS_LOADING:
      return { ...state, thresholdLoader: action.payload };
    case FETCH_THRESHOLDS_SUCCESS:
      return { ...state, thresholds: action.payload, thresholdLoader: false };
    case THRESHOLD_NOTIFICATIONS_IS_LOADING:
      return { ...state, thresholdNotificationsLoader: action.payload };
    case FETCH_THRESHOLD_NOTIFICATIONS_SUCCESS:
      return { ...state, notifications: action.payload, thresholdNotificationsLoader: false };
    case THRESHOLD_NOTIFICATION_SELECTED_ROWS:
      return { ...state, selectedThresholdNotificationRows: action.payload };
    case DELETING_THRESHOLDS:
      return { ...state, deletingThresholds: action.payload };
    case DELETING_THRESHOLDS_SUCCESS:
      return { ...state, deletingThresholds: false, deletingThresholdsSuccess: true };
    case MODIFYING_THRESHOLD:
      return { ...state, modifyingThreshold: action.payload };
    case MODIFYING_THRESHOLD_RESPONSE:
      return { ...state, modifyingThresholdResponse: action.payload, modifyingThreshold: false };
    case CREATING_THRESHOLD:
      return {
        ...state,
        creatingThreshold: action.payload,
      };
    case CREATING_THRESHOLD_RESPONSE:
      return {
        ...state,
        creatingThreshold: false,
        creatingThresholdResponse: action.payload,
      };
    default:
      return state;
  }
};

export default thresholdNotifications;
